import { useEffect, useMemo, useRef } from 'react';
import { IoMdPersonAdd } from "react-icons/io";
import { IoAddCircleOutline } from 'react-icons/io5';
import { Search } from '../../../../components';
import { AddContact, Options, Selected } from '../../styled';
import ContactItem from '../ContactItem';
import SelectedItem from '../SelectedItem';
import SkeletonLoader from '../SkeletonLoader';

const ContactsStep = ({
    contacts,
    contactsSelected,
    searchInContacts,
    setSearchInContacts,
    displayedPeople,
    setDisplayedPeople,
    onSelectContact,
    onRemoveContact,
    onNewContact,
    loading,
    onFilterContacts
}) => {
    const listRef = useRef(null);

    // Scroll handler
    const handleScroll = () => {
        const element = listRef.current;
        if (element && element.scrollTop + element.clientHeight + 50 >= element.scrollHeight) {
            setDisplayedPeople(prevCount => prevCount + 50);
        }
    };

    useEffect(() => {
        const element = listRef.current;
        if (element) {
            element.addEventListener('scroll', handleScroll);
            return () => element.removeEventListener('scroll', handleScroll);
        }
    }, []);

    // Filtered and paginated data
    const visibleData = useMemo(() => {
        return contacts?.filter(onFilterContacts).slice(0, displayedPeople);
    }, [contacts, onFilterContacts, displayedPeople]);

    return (
        <div className="content">
            <div className='box--y'>
                <span className='add--'>
                    <span onClick={onNewContact}>
                        novo contato
                        <IoAddCircleOutline />
                    </span>
                </span>
                <Search
                    className='search--'
                    value={searchInContacts}
                    onChange={(e) => setSearchInContacts(e.target.value)}
                />
                <Options ref={listRef}>
                    {loading ? (
                        <SkeletonLoader count={15} />
                    ) : (
                        <>
                            {contacts?.length > 0 && visibleData?.map((item) => (
                                <ContactItem
                                    key={item.id}
                                    item={item}
                                    onClick={onSelectContact}
                                />
                            ))}
                        </>
                    )}
                </Options>
            </div>
            <div className='box--y'>
                <span className='tag--'>
                    <label>Selecionados :</label>
                </span>
                <Selected>
                    {contactsSelected?.length > 0 &&
                        contactsSelected?.map((item) => (
                            <SelectedItem
                                key={item.id}
                                item={item}
                                type="contact"
                                onRemove={onRemoveContact}
                            />
                        ))
                    }
                </Selected>
            </div>
        </div>
    );
};

export default ContactsStep;